export default "__VITE_ASSET__CCTS8mvt__"